/**
 * Is the public Supabase Storage object at `publicUrl` present and last written within `maxAgeMs`?
 *
 * Every Storage upload takes a per-object advisory lock (pg_advisory_xact_lock, ~159 ms mean, max 24.8 s),
 * which made avatar uploads ~58% of all database time. A HEAD on the public URL is one plain SELECT and
 * lets callers skip re-uploading an avatar that is already stored. Any doubt (timeout, non-200, missing
 * or unparsable Last-Modified) returns false so the caller uploads exactly as before.
 */
export async function isStorageObjectFresh(publicUrl: string, maxAgeMs: number, fetchImpl: typeof fetch = fetch, now: number = Date.now()): Promise<boolean> {
    try {
        const response = await fetchImpl(publicUrl, { method: "HEAD", signal: AbortSignal.timeout(4000) })
        if (!response.ok) return false
        const lastModified = Date.parse(response.headers.get("last-modified") ?? "")
        if (!Number.isFinite(lastModified)) return false
        return now - lastModified < maxAgeMs
    } catch {
        return false
    }
}
